import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import Auth from '../../../shared/Auth';
import CurrentProfile from '../../EnergyEfficiencyApp/EEReports/CurrentProfile';
import ChartLoader from '../../Loaders/ChartLoader';
import TableLoader from '../../Loaders/TableLoader';
import FeederDataTable from './FeederDataTabale';
import axios from '../../../utils/axiosClient';
class FeederCurves extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      currentProfile: {
        lc_r: [],
        lc_y: [],
        lc_b: [],
        flc_r: [],
        flc_y: [],
        flc_b: [],
        time: [],
      },
      init: true,
      deviceId: 0,
      selected: 0,
    };
    this.bindData = this.bindData.bind(this);
  }

  componentDidMount() {
    this.bindData(this.props.obj, 'dropdown');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.obj.type !== this.props.obj.type ||
      nextProps.obj.id !== this.props.obj.id
    ) {
      this.bindData(nextProps.obj, 'dropdown');
    }
  }

  async bindData(obj, type) {
    this.setState({
      init: true,
    });
    const current = this;
    const checkToken = await Auth();
    if (checkToken) {
      axios.get(`analytics/loadcurrentvalues/${obj.type}/${obj.id}`).then(
        (response) => {
          if (response.status === 200) {
            const lc_r = [];
            const lc_y = [];
            const lc_b = [];
            const flc_r = [];
            const flc_y = [];
            const flc_b = [];
            response.data.result.forEach((k) => {
              const day = k.reportedDateTime.substr(8, 2);
              const month = k.reportedDateTime.substr(5, 2);
              const year = k.reportedDateTime.substr(0, 4);
              const time = k.reportedDateTime.substr(11, 8);

              lc_r.push([
                Date.parse(`${month}/${day}/${year} ${time}`),
                parseFloat(k.lc_Ir),
              ]);
              lc_y.push([
                Date.parse(`${month}/${day}/${year} ${time}`),
                parseFloat(k.lc_Iy),
              ]);
              lc_b.push([
                Date.parse(`${month}/${day}/${year} ${time}`),
                parseFloat(k.lc_Ib),
              ]);

              flc_r.push([
                Date.parse(`${month}/${day}/${year} ${time}`),
                parseFloat(k.fC_Ir),
              ]);
              flc_y.push([
                Date.parse(`${month}/${day}/${year} ${time}`),
                parseFloat(k.fC_Iy),
              ]);
              flc_b.push([
                Date.parse(`${month}/${day}/${year} ${time}`),
                parseFloat(k.fC_Ib),
              ]);
            });
            current.setState({
              data:
                type === 'rowclick' ? this.state.data : response.data.result,
              currentProfile: {
                lc_r,
                lc_y,
                lc_b,
                flc_r,
                flc_y,
                flc_b,
              },
              init: false,
              selected: 0,
            });
          }
        },
        (err) => {
          current.setState({
            init: false,
            selected: obj.key,
          });
          console.log(err);
        }
      );
    }
  }

  onTableRowClick(obj) {
    // let ojb={
    //     type:'feeder',
    //     id: obj.deviceId,
    //     key:obj.id
    // }
    this.setState({
      selected: obj.id,
      deviceId: obj.deviceId,
    });

    // this.bindData(ojb,'rowclick');
  }

  render() {
    const { selected, init, data, deviceId } = this.state;
    // eslint-disable-next-line no-underscore-dangle
    const _chartLoader = <ChartLoader height="150" width="600" />;
    let currentProfile = _chartLoader;
    let fdrDataTable = <TableLoader height="150" width="600" />;

    if (!init) {
      currentProfile = (
        <Col lg={12} className="box-border">
          <CurrentProfile deviceId={deviceId}></CurrentProfile>
        </Col>
      );

      fdrDataTable = (
        <FeederDataTable
          data={data}
          selected={selected}
          onTableRowClick={this.onTableRowClick.bind(this)}
        ></FeederDataTable>
      );
    }

    return (
      <div>
        <Col
          lg={selected === 0 ? 12 : 6}
          md={selected === 0 ? 12 : 6}
          style={{ marginTop: '10px' }}
        >
          {fdrDataTable}
        </Col>
        {selected !== 0 ? (
          <Col lg={6} md={6}>
            {currentProfile}
          </Col>
        ) : null}
      </div>
    );
  }
}
export default FeederCurves;
